import React, {useEffect, useRef, useState} from 'react'
import moment from 'moment/moment'
import {useLocation} from 'react-router'
import {copyText} from '../../../../../components/renders'
import {KTSVG} from '../../../../../_metronic/helpers'
import {LoadingData} from '../../../../../components/LoadingData'
import {
  getListePieceViaType,
  getSearchPieceTypePiece,
  refusDemontage,
  updatePieceDemontage,
} from '../../../../../components/requests'
import Carousel from '../../../../../components/Carousel'
import {SearchPiece} from '../../../../../components/SearchPiece'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'

const isEmpty = (obj: any) => !obj || Object.keys(obj).length === 0 // pour verifier si un objet est vide ou pas
const DemontageModal = (props) => {
  const {
    objectSearch = null,
    pieces = [],
    panier = null,
    setPanier = null,
    retraitDepot,
    dataClientInfos,
    setDemandeClient = null,
    idClientDmdPieceDemonter,
    setPiecesProps,
    piecesProps,
  } = props

  const [imgArr, setImgArr] = useState<any>([])
  const location = useLocation()
  const state = location.state as any
  const [detail, setDetail] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [showVehicle, setShowVehicle] = useState(false)

  const [codeVehicule, setCodeVehicule] = useState('')
  const [idPieceProposee, setIdPieceProposee] = useState<any>(null)
  const [idPieceEntree, setIdPieceEntree] = useState<any>(null)
  const [idDemande, setIdDemande] = useState<any>(null)

  const [pieceTypePiece, setPieceTypePiece] = useState(null)
  const [selectedSearchValue, setSelectedSearchValue] = useState<any>('')
  const [searchValue, setSearchValue] = useState<any>('')
  const [pieceSpinner, setPieceSpinner] = useState<boolean>(false)
  const [resultShowPiece, setResultShowPiece] = useState<boolean>(false)
  const [clearInput, setClearInput] = useState<boolean>(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [formattedCodePiece, setFormattedCodePiece] = useState('')

  const modalRef = useRef<HTMLDivElement | null>(null)
  const [checkCopy, setCheckCopy] = useState<string | null>(null)

  const pieceDemonter = panier.filter(
    (p) => p.idCLientDemandePiece == idClientDmdPieceDemonter && p.isDemontage === true
  )

  const getEtatColorIndicator = () => {
    let etatColorIndicator
    const etat = detail?.etat?.libelle?.toLowerCase()
    if (etat) {
      switch (etat) {
        case 'très bien':
          etatColorIndicator = 'primary'
          break
        case 'bien':
          etatColorIndicator = 'success'
          break
        case 'moyen':
          etatColorIndicator = 'yellow'
          break
        case 'nc':
          etatColorIndicator = 'orange'
          break
        default:
          etatColorIndicator = 'grey'
          break
      }
      return etatColorIndicator
    } else return ''
  }

  useEffect(() => {
    if (objectSearch !== null) {
      setLoading(true)
      if (formattedCodePiece && objectSearch.refereSearch) {
        objectSearch.refereSearch.codePiece = formattedCodePiece
      }
      setCodeVehicule(objectSearch?.refereSearch?.codeVehicule)
      setSearchValue(objectSearch?.nomPiece)
      setIdPieceProposee(objectSearch?.idPieceProposee)
      setIdDemande(objectSearch?.idDemande)
      getListePieceViaType(
        objectSearch?.idTypePiece ?? 'horsNomenclature',
        objectSearch?.page,
        objectSearch?.refereSearch,
        objectSearch?.marque,
        objectSearch?.model,
        objectSearch?.isAgregate,
        objectSearch?.clientId,
        objectSearch?.sortField,
        objectSearch?.sortOrder,
        objectSearch?.piecePubliable
      ).then((response) => {
        if (response?.data !== undefined) {
          if (response?.data?.length) {
            const dataFormat = response?.data[0]
            setIdPieceEntree(dataFormat?.id)
            const updatedDetail = {
              ...dataFormat,
              prixVenteTTC: Number(
                Number(Number(dataFormat?.prix) * (1 + Number(dataFormat?.tauxTva) / 100))?.toFixed(
                  2
                ) ?? 0
              ),
              statut: 'NOUV',
            }
            setDetail(updatedDetail)
          } else {
            setDetail([])
          }
          setLoading(false)
        }
      })
    }
  }, [objectSearch, formattedCodePiece])

  useEffect(() => {
    const modal = modalRef.current

    const handleModalShown = () => {
      setShowVehicle(false)
    }

    if (modal) {
      modal.addEventListener('shown.bs.modal', handleModalShown)
    }

    if (modal) {
      modal.addEventListener('hidden.bs.modal', handleModalShown)
    }

    return () => {
      if (modal) {
        modal.removeEventListener('shown.bs.modal', handleModalShown)
        modal.removeEventListener('hidden.bs.modal', handleModalShown)
      }
    }
  }, [])

  useEffect(() => {
    // Pour les photos de pièces
    let arrTemp: any = []
    detail?.images?.length > 0 &&
      detail?.images?.map((i) => {
        arrTemp.push(i.image)
      })
    setImgArr(arrTemp)
  }, [detail])

  const getDayDiff = (date: Date) => {
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    return Math.round(diff / (1000 * 60 * 60 * 24))
  }

  const renderInfo = () => {
    const codePiece = `${detail?.piece?.typePiece?.sousCategorie.categorie.code}${detail?.piece?.typePiece?.sousCategorie.code}${detail?.piece?.typePiece?.code}${detail?.vehiculeEntre?.numero}`

    const capitalizaFirstletter = (str: string = '') => {
      if (str != null) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      }
    }

    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence constructeur</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{detail?.piece?.referenceConstructeur || ''}</div>
            {detail?.piece?.referenceConstructeur &&
              (checkCopy !== detail?.piece?.referenceConstructeur ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.piece?.referenceConstructeur, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Prix constructeur (HT)</div>
          <div className='fs-4 bold'>
            {Number(detail?.piece?.prixConstructeur)?.toFixed(2) ?? ''} €
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence pièce</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>
              {detail?.piece?.typePiece?.sousCategorie.categorie.code}
              {detail?.piece?.typePiece?.sousCategorie.code}
              {detail?.piece?.typePiece?.code}
              {detail?.vehiculeEntre?.numero}
            </div>
            {codePiece !== '' &&
              (checkCopy !== codePiece ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(codePiece, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Etat</div>
          <div className='fs-4 bold'>
            <span
              className={`badge badge-light-${getEtatColorIndicator()} border border-light-${getEtatColorIndicator()} w-100 justify-content-center fs-5`}
            >
              {capitalizaFirstletter(detail?.etat?.libelle) || ''}
            </span>
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence BAC</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{detail?.stockageBac || ''}</div>
            {detail?.stockageBac &&
              (checkCopy !== detail?.stockageBac ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.stockageBac, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Référence casier</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{detail?.stockageAllee || ''}</div>
            {detail?.stockageAllee &&
              (checkCopy !== detail?.stockageAllee ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(detail?.stockageAllee, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Commentaire</div>
          <div
            className='fs-4 text-gray-700 text-end overflow-y-auto'
            style={{
              maxHeight: '150px',
              maxWidth: '20vw',
            }}
          >
            {detail?.commentaire || ''}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date de stockage</div>
          <div className='fs-4 bold'>
            {detail?.stockageDate ? moment(detail?.stockageDate).format('DD/MM/YYYY') : ''}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Jour de stockage</div>
          <div className='fs-4 bold'>
            {detail?.stockageDate ? getDayDiff(new Date(detail?.stockageDate)) : ''}
          </div>
        </div>
      </div>
    )
  }

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  const searchPieceTypePiece = (e) => {
    const inputValue = e.target.value
    setSearchValue(inputValue)
    setSelectedSearchValue('')
    setClearInput(false)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      if (inputValue !== '') {
        setPieceSpinner(true)
        getSearchPieceTypePiece(inputValue)
          .then((res) => {
            if (res?.status === 200) {
              if (res?.data !== undefined) {
                setResultShowPiece(true)
                setPieceTypePiece(res.data)
                setPieceSpinner(false)
              }
            }
          })
          .catch(() => {
            console.log('error')
          })
      }
    }, 800)
  }

  const liaisonPieceDemontage = () => {
    const pieceLibelle = selectedSearchValue !== '' ? selectedSearchValue : searchValue
    Swal.fire({
      title: 'Attention',
      text:
        'La pièce ' +
        pieceLibelle +
        ' sera associée à cette demande de démontage parc et une commande va etre générée pour le client',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
      didOpen: (popup) => {
        //met le popup de confirmation en dessus de modal actuel
        popup.parentElement?.style.setProperty('z-index', '99999', 'important')
      },
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        if (idPieceProposee !== null && idPieceEntree !== null && idDemande !== null) {
          const idToastSend = toast.loading('Association en cours...')

          updatePieceDemontage(idPieceProposee, idPieceEntree, idDemande).then((response) => {
            if (response?.status === 200 && response.data) {
              const dataPanier = response?.data?.demandePieceProposee
              const dataDemande = response.data?.demande

              //mise à jour de la statut de la demande
              if (setDemandeClient) setDemandeClient(dataDemande)

              setDetail((prev) => ({
                ...prev,
                statut: 'VALIDE',
              }))

              let statut_piece_panier = 'PROPO'
              if (dataPanier?.isAccepted) {
                statut_piece_panier = 'ACCEP'
              } else if (dataPanier?.isRefused) {
                statut_piece_panier = 'REFUS'
              } else if (dataPanier?.isAcceptedBlocked) {
                statut_piece_panier = 'BLOQU'
              } else if (dataPanier?.dateAnnulation !== null) {
                statut_piece_panier = 'CANCE'
              } else if (dataPanier?.dateEchec !== null) {
                statut_piece_panier = 'ECHEC'
              }

              //mise à jour dans le panier:
              setPanier((prevPanier: any[]) => {
                return prevPanier.map((item) => {
                  if (item.idPiecePropose === idPieceProposee) {
                    // TVA POT toujours 20%
                    const isProfessionnel =
                      dataClientInfos && dataClientInfos?.professionnel === false ? 10 : 20

                    const pieceExclue = !!dataClientInfos?.sauf?.some(
                      (item) => item.label === dataPanier.nomTypePieceProposee
                    )
                    const fraisOffert = !!dataClientInfos?.fraisPortOffert && !pieceExclue
                    const fraisDePort =
                      fraisOffert || retraitDepot ? 0 : Number(dataPanier?.prixTransport)

                    const taux = Number(dataPanier?.tauxRemise ?? 0)
                    const tauxTva = Number(dataPanier?.tauxTva ?? 0)
                    // const prix = Number(dataPanier.prix ?? 0)

                    const prixReferentielHt = dataPanier?.prixReferentiel ?? 0
                    const prixReferentielHtInitial = prixReferentielHt
                    const prixReferentielTtc = prixReferentielHt * (1 + isProfessionnel / 100) ?? 0

                    const prixVenteProposeeHt =
                      prixReferentielHt - prixReferentielHt * (taux / 100) ?? 0
                    const prixVenteProposeeTtc =
                      prixVenteProposeeHt * (1 + isProfessionnel / 100) ?? 0
                    const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

                    return {
                      ...item,
                      statut: statut_piece_panier,
                      nomTypePiece: dataPanier?.pieceEntre?.piece?.typePiece?.nom,
                      etat: dataPanier?.pieceEntre?.etat.libelle,
                      refConstructeur: dataPanier?.pieceEntre?.piece.referenceConstructeur,
                      idPieceEntre: dataPanier?.pieceEntre?.id,
                      tauxRemise: Number(taux?.toFixed(1)),
                      fraisDePort: Number(fraisDePort?.toFixed(2)),
                      montantRemise: Number((prixReferentielHt - prixVenteProposeeHt).toFixed(2)),
                      prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
                      prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
                      prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
                      prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
                      prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
                      dateAcceptation: dataPanier?.dateAcceptation,
                      refCasier: dataPanier?.pieceEntre?.stockageBac,
                      refCasierAllee: dataPanier?.pieceEntre?.stockageAllee,
                      commentaires: dataPanier?.pieceEntre?.commentaire,
                      prixConstructeur: dataPanier?.pieceEntre?.piece.prixConstructeur,
                      codePieceEntree: dataPanier?.pieceEntre?.code,
                      images: dataPanier?.pieceEntre?.images?.map((item: any) => item?.image),
                    }
                  }
                  return item
                })
              })

              toast.update(idToastSend, {
                render: 'Association terminée avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            } else {
              toast.update(idToastSend, {
                render: 'Association échouée',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
              })
            }
          })
        }
      }
    })
  }

  const handleRefus = () => {
    Swal.fire({
      title: 'Attention',
      text:
        "Voulez-vous vraiment annuler l'association du pièce " +
        searchValue +
        ' à cette demande de démontage ?',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastSend = toast.loading('Annulation en cours...')
        if (idPieceProposee !== null && idPieceEntree !== null && idDemande !== null) {
          refusDemontage(idPieceProposee, idDemande, panier).then((response) => {
            if (response?.status === 200 && response.data) {
              const dataPanier = response?.data?.demandePieceProposee
              const dataDemande = response.data?.demande

              //mise à jour du statut de la demande
              if (setDemandeClient) setDemandeClient(dataDemande)

              //mise à jour du panier:
              setPanier((prevPanier: any[]) => {
                return prevPanier.map((item) => {
                  if (item.idPiecePropose === idPieceProposee) {
                    return {
                      ...item,
                      statut: 'REFUS',
                      isAcceptedBlocked: false,
                      dateRefus: dataPanier?.dateRefus,
                    }
                  }
                  return item
                })
              })

              if (setPiecesProps) {
                const updatedPieces = piecesProps?.map((p) =>
                    p.id === dataPanier?.clientDemandePiece?.id
                        ? {...p, clientDemandePieceProposee: [dataPanier]} : p
                )
                setPiecesProps(updatedPieces)
              }

              toast.update(idToastSend, {
                render: 'Annulation terminé avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            } else {
              toast.update(idToastSend, {
                render: 'Annulation échouée',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
              })
            }
          })
        }
      }
    })
  }

  const renderPartialInfoVehicle = () => {
    const vehicleDetail = detail.vehiculeEntre
    return (
      <div className='overflow-auto' style={{maxHeight: '500px'}}>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Marque</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.marque?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Modèle</div>
          <div className='fs-4 bold'>{vehicleDetail?.vehicule?.modele?.nom || ''}</div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Immatriculation</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.immatriculation || ''}</div>
            {vehicleDetail?.immatriculation &&
              (checkCopy !== vehicleDetail?.immatriculation ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.immatriculation, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Numéro d’identification</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.numero || ''}</div>
            {vehicleDetail?.numero &&
              (checkCopy !== vehicleDetail?.numero ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.numero, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>Date première immatriculation</div>
          <div className='fs-4 bold'>
            {vehicleDetail?.datePremiereImmat == ''
              ? ''
              : moment(vehicleDetail?.datePremiereImmat)?.format('DD/MM/YYYY')}
          </div>
        </div>
        <div className='d-flex justify-content-between mb-3'>
          <div className='bold text-gray-600 fs-4'>N° série</div>
          <div className='d-flex gap-2'>
            <div className='fs-4 bold'>{vehicleDetail?.vin || ''}</div>
            {vehicleDetail?.vin &&
              (checkCopy !== vehicleDetail?.vin ? (
                <i
                  className='ki-duotone ki-copy cursor-pointer fs-2'
                  onClick={(e) => handleCopie(vehicleDetail?.vin, e)}
                ></i>
              ) : (
                <i className='ki-duotone ki-copy-success fs-2'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='modal fade' tabIndex={-1} id='modal_details_demont' ref={modalRef}>
        <div className='modal-dialog modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>
                {loading
                  ? 'Détails pièces'
                  : `Détails de ${detail?.piece?.typePiece?.nom || 'pièces'}`}
              </h4>
              {/*début affichage du filtre des pièces*/}
              <div className='w-50'>
                <div className='input-group mb-2'>
                  <input
                    type='text'
                    className='form-control form-control-md'
                    value={codeVehicule}
                    disabled={true}
                  />
                </div>
                <div className=''>
                  <SearchPiece
                    inputClassName={'form-control form-control-md h-200'}
                    placeholder={'Rech. par libellé de la pièce'}
                    onChange={(e) => searchPieceTypePiece(e)}
                    resultatPiece={pieceTypePiece}
                    value={selectedSearchValue || searchValue}
                    setSearchValue={setSearchValue}
                    pieceSpinner={pieceSpinner}
                    resultShowPiece={resultShowPiece}
                    clearInput={clearInput}
                    selectedSearchValue={selectedSearchValue}
                    setSelectedSearchValue={setSelectedSearchValue}
                    showPieceHn={false}
                    isDemontage={true}
                    onSelect={(pieceTypePiece) => {
                      if (pieceTypePiece) {
                        setSearchValue(pieceTypePiece?.nom)
                        setSelectedSearchValue(pieceTypePiece?.nom)
                        const fullCode = `${pieceTypePiece?.sousCategorie?.categorie?.code}${pieceTypePiece?.sousCategorie?.code}${pieceTypePiece?.code}`
                        setFormattedCodePiece(fullCode)
                      } else {
                        setFormattedCodePiece('')
                      }
                      setResultShowPiece(false)
                      setClearInput(true)
                    }}
                  />
                </div>
              </div>
              {/*début affichage du filtre des pièces*/}
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                {!showVehicle && (
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                )}
              </div>
            </div>
            <div className='modal-body'>
              {loading ? (
                <LoadingData />
              ) : !isEmpty(detail) ? (
                <>
                  <div>
                    {/*debut bloc du droite*/}
                    <div>
                      <div
                        className={
                          !showVehicle ? 'd-flex align-items-center justify-content-between' : ''
                        }
                      >
                        {pieces?.length > 0 && !showVehicle && (
                          <div style={{width: '40px', height: '40px'}}>
                            <button
                              className='btn btn-light rounded-circle d-flex align-items-center justify-content-center'
                              style={{width: '40px', height: '40px'}}
                            >
                              <i className='ms-1 bi bi-chevron-left'></i>
                            </button>
                          </div>
                        )}

                        <div className='d-flex gap-4 w-100'>
                          <div style={{width: '600px'}}>
                            <Carousel
                              loading={true}
                              imagesArray={imgArr}
                              nomPiece={detail?.piece?.typePiece?.nom}
                              taille={'600x400'}
                              width={126}
                              isVehic={showVehicle}
                              etatColorIndicator={
                                !showVehicle ? getEtatColorIndicator() : undefined
                              }
                            />
                            <div>
                              <div className='d-flex flex-row-reverse justify-content-between align-items-center'>
                                <div className='fs-2 mb-4 mt-4 text-end'>
                                  Prix de vente TTC : {Number(detail?.prixVenteTTC)?.toFixed(2)} €
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className='card shadow-none d-flex flex-column w-50'>
                            <div className='mb-6'>
                              <div className='card-header border-bottom-0 fs-2 d-flex align-items-center'>
                                Information du produit
                              </div>
                              <hr className={'text-gray-400 mx-9'} />
                              <div className='card-body mt-n7'>
                                <div>{renderInfo()}</div>
                              </div>
                            </div>

                            {/* début Affichage partielle des données du véhicule */}
                            <div>
                              <h4 className='modal-title ms-9 mt-n12'>Information du véhicule</h4>
                              <hr className={'text-gray-400 mx-9'} />
                              <div className='card-body mt-n7'>
                                <div>{renderPartialInfoVehicle()}</div>
                              </div>
                            </div>
                            {/* fin Affichage partielle des données du véhicule */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*fin bloc du droite*/}
                  </div>
                </>
              ) : (
                <div
                  className='d-flex justify-content-center align-items-center'
                  style={{height: '50px'}}
                >
                  <span>Aucune pièce en stock trouvée !</span>
                </div>
              )}
            </div>
            <div className='modal-footer'>
              {pieceDemonter.length > 0 && pieceDemonter[0]?.idPieceEntre !== null ? (
                <span className='order-first me-auto text-gray-600 fs-6'>
                  La pièce démontée{' '}
                  {pieceDemonter[0]?.refConstructeur ?? detail?.piece?.referenceConstructeur} a été
                  associée à la demande et la commande envoyée en préparation{' '}
                  {moment(pieceDemonter[0]?.dateAcceptation).format('DD-MM-YYYY [à] hh:mm:ss')}
                </span>
              ) : pieceDemonter.length > 0 && pieceDemonter[0]?.statut === 'REFUS' ? (
                <span className='order-first me-auto text-danger fs-6'>
                  La pièce démontée{' '}
                  {pieceDemonter[0]?.refConstructeur ?? detail?.piece?.referenceConstructeur} a été
                  refusée
                  {pieceDemonter[0]?.dateRefus && (
                    <> le {moment(pieceDemonter[0]?.dateRefus).format('DD-MM-YYYY [à] hh:mm:ss')}</>
                  )}
                </span>
              ) : (
                !loading && (
                  <>
                    <button
                      type='button'
                      className='btn btn-light-danger me-auto'
                      disabled={detail?.length <= 0}
                      onClick={() => handleRefus()}
                    >
                      Annuler cette association
                    </button>

                    <button
                      type='button'
                      className='btn btn-light-primary'
                      disabled={detail?.length <= 0 || detail?.statut === 'VALIDE'}
                      onClick={() => liaisonPieceDemontage()}
                    >
                      Lier cette pièce à la demande de démontage
                    </button>
                  </>
                )
              )}
              <button type='button' className={`btn btn-light`} data-bs-dismiss='modal'>
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {DemontageModal}
